import React from 'react';

import { Grid } from '@material-ui/core';

import MainLayout from '../../common/components/MainLayout';
import RightPanel from '../containers/RightPanel';
import SiteSelectPanel from '../containers/SiteSelectPanel';

import classes from '../../css/getCSS';

const SearchLayout = (props) => {
  return (
    <MainLayout
      isAuthenticated={props.isAuthenticated}
      activeLink={props.activeLink}
      dashActiveLink={props.dashActiveLink}
      rootClass={classes.dashboardLayout}
    >
      <Grid container spacing={16} className={[classes.marginTopSM, classes.marginTopXS].join(' ')}>
        <Grid item md={3} xs={12} sm={12} className={[classes.noPaddingXS, classes.noPaddingSM].join(' ')} style={{ position: 'relative' }}>
          {props.leftPanel}
        </Grid>
        <Grid item md={6} xs={12} sm={12}>
          {props.children}
        </Grid>
        <Grid item md={3} xs={12} sm={12}>
          <RightPanel />
          <SiteSelectPanel />
        </Grid>
      </Grid>
    </MainLayout>
  );
};

export default SearchLayout;



// WEBPACK FOOTER //
// ./src/dashboard/components/SearchLayout.js